import { Issue } from "../../../../../../models";
import { ProducerModelPredicate } from "@aws-amplify/datastore";

export default class DataStoreQueryIssuesByLocationIdPredicateFactory<T extends Issue> {
    create(locationId: string): ProducerModelPredicate<T> {
        return (model => model.locationId("eq", locationId as any))
    }
}